import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home.component';
import { ProjectComponent } from '../project/project.component';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { PanelListComponent } from '../panel-list/panel-list.component';
import { RecruiterMainComponent } from '../recruiters/recruiter.main.component';
import { ContributorsComponent } from '../contributors/contributors.component';
import { PerformanceTrackerComponent } from '../performance-tracker/performance-tracker.component';
import { SurveyBuilderResearchComponent } from '../survey-builder-research/survey-builder-research.component';
import { BiReportComponent } from '../bi-report/bi-report.component';
import { FunnelReportComponent } from '../funnel-report/funnel-report.component';
import { VisibilityControlComponent } from '../visibility-control/visibility-control.component';
import { DiaryTestComponent } from '../diary/diary-test/diary-test.component';
import { DiaryDayWiseComponent } from '../diary/diary-day-wise/diary-day-wise.component';
import { DiaryCenterWiseComponent } from '../diary/diary-center-wise/diary-center-wise.component';
import { StudySurveyComponent } from '../study-survey/study-survey.component';
import { CallRecordingComponent } from '../repository/call-recording/call-recording.component';
import { ProductTestingComponent } from './product-testing/product-testing.component';
import { PTEventComponent } from './pt-event/pt-event.component';
import { StudySupersetComponent } from './study-superset/study-superset.component';
import { DashboardSuiteComponent } from './dashboard-suite/dashboard-suite.component';

const routes: Routes = [{
  path: '', component: HomeComponent,
  children: [
    {
      path: 'projects',component: ProjectComponent,
    },
    { path: 'panel-list/:id', component: PanelListComponent },
    {
      path: 'projects/:id',component: DashboardComponent
    },
    {
      path: 'recruiters',component: RecruiterMainComponent
    },
    {
      path: 'recruiter/:id',component: DashboardComponent
    },
    {
      path: 'contributors',component: ContributorsComponent,
    },
    {
      path: 'home/recruiters-list/:id',component: RecruiterMainComponent
    },
    {
      path: 'dashboard',component: DashboardComponent,
    },
    {
      path: 'performance-tracker/:id',
      component: PerformanceTrackerComponent
    },
    {
      path: 'product-testing/:id',
      component: ProductTestingComponent
    },
    // {
    //   path: 'product-testing/rq/:id',
    //   component: PTEventComponent
    // },
    // {
    //   path: 'product-testing/pre/:id',
    //   component: PTEventComponent
    // },
    // {
    //   path: 'product-testing/product-delivery/:id',
    //   component: PTEventComponent
    // },
    // {
    //   path: 'product-testing/RQ/:id',
    //   component: PTEventComponent
    // },
    {
      path: 'pt-event/:event/:id',
      component: PTEventComponent
    },
    {
      path: 'research-survey/:id',
      component: SurveyBuilderResearchComponent
    },
    {
      path: 'bi-report/:id',
      component: BiReportComponent
    },
    {
      path: 'funnel-report/:id',
      component: FunnelReportComponent
    },
    {
      path: 'term-report/:id',
      component: FunnelReportComponent
    },
    {
      path: 'utm-report/:id',
      component: FunnelReportComponent
    },
    {
      path: 'summary-report/:id',
      component: FunnelReportComponent
    },
    {
      path: 'visibility/:id',
      component: VisibilityControlComponent
    },
    {
      path: 'dashboard/:id',
      component: RecruiterMainComponent
    },
    {
      path: 'projects/dashboard/:id',
      component: RecruiterMainComponent
    },
    { path: 'dairy-dashboard/test', component: DiaryTestComponent },
    { path: 'dairy-dashboard/day-wise/:id', component: DiaryDayWiseComponent},
    { path: 'dairy-dashboard/center-wise/:id', component: DiaryCenterWiseComponent },
    { path: 'survey/:uuid/:channel', component: StudySurveyComponent },
    { path: 'repository-report/call-recording/:uuid', component: CallRecordingComponent },
    { path: 'dash-suite/:id', component: DashboardSuiteComponent },
    { path: 'dash-suite/:name/:id', component: StudySupersetComponent },
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule {}
